import { isEmpty } from 'lodash';

export default function withActions (obj, actions) {
    if (!isEmpty(obj) && !isEmpty(actions)) {
        for (const i in actions) {
            obj[i] = actions[i];
        }
    }
}
